/**
 * AuthRequireModal.js
 * A standardized modal to prompt users to login.
 */
import { ModalManager } from '../../utils/ModalManager.js';

export class AuthRequireModal {
    constructor() {
        this.render();
    }

    render() {
        if (document.getElementById('auth-require-modal-overlay')) return;

        // Overlay
        const overlay = document.createElement('div');
        overlay.id = 'auth-require-modal-overlay';
        overlay.className = "fixed inset-0 bg-black/60 z-[10000] flex items-center justify-center fade-in backdrop-blur-sm p-4";

        // Modal
        const modal = document.createElement('div');
        modal.className = "bg-white dark:bg-zinc-900 w-full max-w-sm rounded-2xl shadow-xl overflow-hidden animate-slide-up border border-zinc-100 dark:border-zinc-800";

        modal.innerHTML = `
            <div class="p-6 text-center">
                <div class="w-16 h-16 bg-violet-100 dark:bg-violet-900/30 text-violet-600 dark:text-violet-400 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span class="material-symbols-outlined text-3xl">lock</span>
                </div>
                <h3 class="text-xl font-bold text-gray-900 dark:text-white mb-2">로그인이 필요합니다</h3>
                <p class="text-gray-500 dark:text-gray-400 text-sm leading-relaxed mb-6">
                    이 기능을 사용하시려면 로그인이 필요합니다.<br>
                    로그인 페이지로 이동하시겠습니까?
                </p>
                <div class="flex gap-3">
                    <button id="btn-cancel-auth" class="flex-1 py-3 bg-gray-100 hover:bg-gray-200 dark:bg-zinc-800 dark:hover:bg-zinc-700 text-gray-700 dark:text-gray-300 font-bold rounded-xl transition-colors">
                        취소
                    </button>
                    <button id="btn-confirm-auth" class="flex-1 py-3 bg-violet-600 hover:bg-violet-700 text-white font-bold rounded-xl transition-colors shadow-lg shadow-violet-200 dark:shadow-none">
                        로그인
                    </button>
                </div>
            </div>
        `;

        overlay.appendChild(modal);
        document.body.appendChild(overlay);

        this.overlay = overlay;

        // Events
        const close = () => {
            overlay.classList.add('opacity-0');
            setTimeout(() => {
                if (overlay.isConnected) overlay.remove();
            }, 300);
            ModalManager.currentModal = null;
        };

        overlay.onclick = (e) => {
            if (e.target === overlay) close();
        };

        modal.querySelector('#btn-cancel-auth').onclick = close;

        modal.querySelector('#btn-confirm-auth').onclick = () => {
            // Close modal first AND Force clean strict
            ModalManager.closeAll();
            window.router.navigate('/login');
        };
    }
}
